import { Box, Button, Divider, Typography, useMediaQuery, useTheme } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';


interface IVMDocTecnicaProps{
    id: string
}

export const VMDocTecnica: React.FC<IVMDocTecnicaProps> = ({id}) =>{
    const navigate = useNavigate();
    const isButtonActive = (path: string) => {
        return location.pathname === path;
    };

    const theme = useTheme();
    const smDown = useMediaQuery(theme.breakpoints.down('sm'));

    return (
    <Box
        display={'flex'}
        flexDirection={smDown? 'column' : 'row'}
        width={'100%'}
    >
        <Box
           display={'flex'}
           flexDirection={'column'}
           alignItems={smDown? 'center' :  'start'}
           width={smDown? '100%' : '50%'}
           padding={1}
        >
            <Typography variant='h6' color={theme.palette.primary.main} marginLeft={1}>Informações Adicionais</Typography>

            <Button variant={isButtonActive(`/information_dam/${id}/technical_characteristics_project`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/technical_characteristics_project`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Características técnicas do Projeto e da Construção</Typography>
            </Button>
            
            {/* <Button variant={isButtonActive(`/information_dam/${id}/basic-projects`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/basic-projects`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Projetos (básico e/ou executivo)</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/as_built_project`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/as_built_project`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Projeto como construído (as built)</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/as_is_project`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/as_is_project`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Projeto como está (as is)</Typography>
            </Button>  */}


            <Button variant={isButtonActive(`/information_dam/${id}/files`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/files/file`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Arquivos da Barragem</Typography>
            </Button>
            {/* <Button variant={isButtonActive(`/information_dam/${id}/files`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/files/foto`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Registros fotográficos</Typography>
            </Button> */}
        </Box>
        <Divider orientation={smDown? 'horizontal' : 'vertical'} flexItem variant="fullWidth" />
        <Box
            display={'flex'}
            flexDirection={'column'}
            alignItems={smDown? 'center' :  'start'}
            width={smDown? '100%' : '50%'}
            padding={1}
        >
            {/* <Typography variant='h6' color={theme.palette.primary.main} padding={0} marginLeft={1}>Informações Adicionais</Typography> */}
            {/* <Button variant={isButtonActive(`/information_dam/${id}/other_projects`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/other_projects`)}>
                <Typography overflow={'hidden'} whiteSpace={'balance'} textOverflow={'ellipsis'} variant='body2'>Outros Projetos</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/geotechnical_and_hydraulic_stability_analysis`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/geotechnical_and_hydraulic_stability_analysis`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Análise de estabilidade geotécnica e hidráulica</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/peer_review`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/peer_review`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Peer Review</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/risk_management_report`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/risk_management_report`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Relatório de Gestão de Riscos</Typography>
            </Button>
        
            <Button variant={isButtonActive(`/information_dam/${id}/adaptation_management_report`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/adaptation_management_report`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Relatório de gestão de mudanças</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/environmental_studies`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/environmental_studies`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Estudos Ambientais</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/hypothetical_breach_studies`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/hypothetical_breach_studies`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Estudos de ruptura hipotética</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/emergency_drill_report`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/emergency_drill_report`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Relatório dos simulados de emergência</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/external_communication_report`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/external_communication_report`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Relatório de comunicação externa</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/closure_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/closure_plan`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Plano de fechamento</Typography>
            </Button>
            
            <Button variant={isButtonActive(`/information_dam/${id}/geo_monitoring_committee_presentation`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/geo_monitoring_committee_presentation`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Apresentação do comitê de vigilância geotécnica</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/geo_monitoring_committee_report`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/geo_monitoring_committee_report`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Relatório do comitê de vigilância geotécnica</Typography>
            </Button>
            
            <Button variant={isButtonActive(`/information_dam/${id}/external_audit_reports`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/external_audit_reports`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Relatórios de auditorias externas</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/igtrb_ipr_reports`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/igtrb_ipr_reports`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Relatórios do IGTRB/IPR</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/lessons_learned_report`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/lessons_learned_report`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Relatório de lições aprendidas</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/annual_audit_report`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/annual_audit_report`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Relatório de auditoria anual</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/geotechnical_investigations_report`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/geotechnical_investigations_report`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Relatório de investigações geotécnicas</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/topographies`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/topographies`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Topografias</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/stress_strain_study`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/stress_strain_study`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Estudo tensão x deformação</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/instrument_sketches`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/instrument_sketches`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Croquis dos instrumentos</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/risk_map`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/risk_map`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Carta de risco</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/photo_records`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/photo_records`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Registros fotográficos</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/satellite_aerial_images`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/satellite_aerial_images`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Imagens satélites ou aéreas</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/waste_characterization_nbr10004`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/waste_characterization_nbr10004`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Caracterização dos rejeitos (ensaios e análises da NBR10004)</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/seismic_analysis_report`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/seismic_analysis_report`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Relatório de análise sísmica</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/tailings_disposal_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/tailings_disposal_plan`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Plano de disposição de rejeitos</Typography>
            </Button>

            <Button variant={isButtonActive(`/information_dam/${id}/communication_plan`) ? 'contained' : 'text'} onClick={() => navigate(`/information_dam/${id}/communication_plan`)}>
                <Typography overflow={'hidden'} whiteSpace={'wrap'} textOverflow={'ellipsis'} variant='body2'>Plano de comunicação</Typography>
            </Button> */}
            
        </Box>
      </Box>
    );
};